import gql from 'graphql-tag';

/**
 * GQL Query for Institutional Interest.
 * Note we are renaming most of the data points to match model expected by institutionalInterest
 */
export const audienceExportGql = gql`
  query ($inst_id: String!, $audience_key: String!) {
    audience {
      audience(inst_id: $inst_id, userKeyConsolidated: "10259442261403795") {
        institutionalInterest {
          name: institutionName
          inst_id: institutionId
          time_spent_seconds: totalTimeSpentWithInstitutionSecondsAllTime
          applied: hasAppliedAllTime
          campus_visits: hasScheduledVisitAllTime
          registered: hasRegisteredAllTime
        }
      }
    }
  }
`;

export const deleteLeadsGql = gql`
  mutation (
    $id: String!
    $inst_id: String!
    $account_id: String!
    $user_ids: [String!]!
  ) {
    listAudienceDelete(
      id: $id
      instId: $inst_id
      accountId: $account_id
      userIds: $user_ids
    ) {
      data {
        instId
        accountId
        id
      }
      message
      code
      rows_modified
    }
  }
`;

export const duplicateListGql = gql`
  mutation (
    $inst_id: String!
    $account_id: String!
    $id: String!
    $name: String!
  ) {
    listDuplicate(
      instId: $inst_id
      accountId: $account_id
      id: $id
      name: $name
    ) {
      data {
        updatedAt
        id
        accountId
        system
        shared
        name
        deletedAt
        orderBy
        attributes
        count
      }
      message
      code
    }
  }
`;

export const exportListGql = gql`
  query (
    $inst_id: String!
    $filtersv2: FilterExpressionInput
    $sort: String
    $user_ids: [String!]!
    $listMemberShip: String
    $search: String
  ) {
    link: downloadAudiences(
      inst_id: $inst_id
      filtersv2: $filtersv2
      sort: $sort
      userIds: $user_ids
      listMemberShip: $listMemberShip
      search: $search
    ) {
      message
      code
      downloadLink
    }
  }
`;

export const exportListAudienceMembersGql = gql`
  query (
    $inst_id: String!
    $account_id: String!
    $id: String
    $filter: String
    $sort: String
    $search: String
  ) {
    link: downloadListAudienceMembers(
      instId: $inst_id
      accountId: $account_id
      id: $id
      sort: $sort
      filter: $filter
      search: $search
    ) {
      downloadLink
      message
      code
      rows_modified
      __typename
    }
  }
`;
try {
    // @ts-ignore
    audienceExportGql.displayName = "audienceExportGql";
    // @ts-ignore
    audienceExportGql.__docgenInfo = { "description": "GQL Query for Institutional Interest.\nNote we are renaming most of the data points to match model expected by institutionalInterest", "displayName": "audienceExportGql", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Audience/AudienceTableHeader/gqlQuery.ts#audienceExportGql"] = { docgenInfo: audienceExportGql.__docgenInfo, name: "audienceExportGql", path: "src/shared/containers/Audience/AudienceTableHeader/gqlQuery.ts#audienceExportGql" };
}
catch (__react_docgen_typescript_loader_error) { }